import { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ImageCard = ({ image, onEdit, onDelete, onToggleFeatured, isSelected, onSelect }) => {
  const [showActions, setShowActions] = useState(false);

  const categoryColors = {
    'حفلات الزفاف': 'bg-rose-500/10 text-blue-700 dark:text-blue-400',
    'التصوير الشخصي': 'bg-blue-500/10 text-blue-700 dark:text-blue-400',
    'المناسبات': 'bg-blue-500/10 text-blue-800 dark:text-blue-400',
    'تصوير المنتجات': 'bg-green-500/10 text-green-700 dark:text-green-400',
    'التصوير التجاري': 'bg-green-500/10 text-green-700 dark:text-green-400',
    'العقارات': 'bg-orange-500/10 text-orange-700 dark:text-orange-400',
  };

  return (
    <div
      className="bg-card rounded-xl overflow-hidden shadow-warm transition-smooth hover:shadow-warm-md"
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      <div className="relative aspect-[4/3] bg-muted">
        <Image
          src={image?.url}
          alt={image?.alt}
          className="w-full h-full object-cover"
        />

        {/* حالة المراجعة: تحت المراجعة | منشورة | مرفوضة */}
        <div className="absolute top-2 left-2 md:top-3 md:left-3 z-10">
          <span
            className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium ${
              (image?.approvalStatus || 'pending') === 'approved'
                ? 'bg-green-600/90 text-white'
                : (image?.approvalStatus || 'pending') === 'rejected'
                  ? 'bg-red-600/90 text-white'
                  : 'bg-amber-500/90 text-white'
            }`}
          >
            {(image?.approvalStatus || 'pending') === 'approved'
              ? 'منشورة'
              : (image?.approvalStatus || 'pending') === 'rejected'
                ? 'مرفوضة'
                : 'تحت المراجعة'}
          </span>
        </div>

        <div className="absolute top-2 right-2 md:top-3 md:right-3 z-10 flex items-center gap-2">
          {image?.isFeatured && (
            <span className="bg-warning text-warning-foreground px-2 py-1 md:px-3 md:py-1.5 rounded-lg text-xs md:text-sm font-medium flex items-center gap-1">
              <Icon name="Image" size={14} className="md:w-4 md:h-4" />
              <span>الغلاف الحالي</span>
            </span>
          )}
        </div>

        {(showActions || window.innerWidth < 1024) && (
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center gap-2 transition-smooth">
            <Button
              variant="secondary"
              size="sm"
              iconName="Edit"
              onClick={() => onEdit(image)}
              className="shadow-lg"
            >
              تعديل
            </Button>
            <Button
              variant="destructive"
              size="sm"
              iconName="Trash2"
              onClick={() => onDelete(image?.id)}
              className="shadow-lg"
            >
              حذف
            </Button>
          </div>
        )}
      </div>
      <div className="p-3 md:p-4">
        <div className="flex items-start justify-between gap-2 mb-2">
          {image?.approvalStatus === 'approved' && !image?.isFeatured ? (
            <button
              onClick={() => onToggleFeatured(image?.id)}
              title="تعيين كغلاف للبطاقة"
              className="flex-shrink-0 px-2 py-1 text-xs font-medium text-primary border border-primary/30 hover:bg-primary/10 rounded-lg transition-smooth"
            >
              تعيين كغلاف
            </button>
          ) : image?.approvalStatus !== 'approved' ? (
            <span
              title="يجب أن تكون الصورة منشورة لتعيينها غلافاً"
              className="flex-shrink-0 px-2 py-1 text-xs font-medium text-muted-foreground border border-border rounded-lg opacity-40 cursor-not-allowed"
            >
              تعيين كغلاف
            </span>
          ) : null}
        </div>

        <div className="flex items-center justify-between">
          <span className={`px-2 py-1 md:px-3 md:py-1.5 rounded-lg text-xs md:text-sm font-medium ${categoryColors?.[image?.category] || 'bg-muted text-foreground'}`}>
            {image?.category}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ImageCard;